import ImpressoPersonalizado from '@/models/impresso/ImpressoPersonalizado';
import http from './ApiConfig';
import { Service } from './Service';

export class ImpressosPersonalizadosService extends Service {
  constructor() {
    super('impressosPersonalizados');
  }

  public GetAllPaginado(nomeModelo: string, limit: number, page: number) {
    return http.get(`${this._nomeControle}?nomeModelo=${nomeModelo}&limit=${limit}&page=${page}`, this.GetHeader());
  }

  public AtivarImpressoPersonalizado(impressosPersonalizadoId: number) {
    return http.patch(`${this._nomeControle}/${impressosPersonalizadoId}/ativar`, this.GetHeader());
  }

  public InativarImpressoPersonalizado(impressosPersonalizadoId: number) {
    return http.patch(`${this._nomeControle}/${impressosPersonalizadoId}/inativar`, this.GetHeader());
  }

  public PostListArquivos(impressosPersonalizadoId: number, modelos: any, tipo: string) {
    return http.post(`${this._nomeControle}/EnviaArquivo/${impressosPersonalizadoId}?tipo=${tipo}`, modelos, this.GetHeader());
  }

  public obterImpressoPersonalizadoPorId(id: number): Promise<ImpressoPersonalizado> {
    return http.get(`${this._nomeControle}/${id}`, this.GetHeader());
  }

  public obterImpressosPersonalizadoSemPaginacao(): Promise<ImpressoPersonalizado> {
    return http.get(`${this._nomeControle}/ObterImpressosPersonalizadosSemPaginacao`, this.GetHeader());
  }
}
